import { useKeyboardIsOpen } from '@akin-home/utils/native';
import React from 'react';
import { useWindowDimensions } from 'react-native';
import styled from 'styled-components/native';
import { DeveloperScreenInfo } from '../../developer/components/DeveloperScreenInfo/DeveloperScreenInfo';
import { useStateStore } from '../../stores/useStateStore';
import { LandscapeDashboardScreenView } from './LandscapeDashboardScreenView';
import { PortraitDashboardScreenView } from './PortraitDashboardScreenView';
import { DashboardScreenViewProps } from './types';

export const DashboardScreenView = (props: DashboardScreenViewProps) => {
  const keyboard_open = useKeyboardIsOpen();
  const setDashboardLayout = useStateStore((state) => state.setDashboardLayout);
  const onContainerLayout = ({ nativeEvent: { layout } }: any) => {
    if (keyboard_open || !layout.width) return;

    setDashboardLayout({
      width: layout.width,
      height: layout.height,
    });
  };

  const { width } = useWindowDimensions();

  // FIXME: Is there a way to change these magic numbers
  const isFullSizedDashAvailable = width >= 1000; /* && height >= 600 */

  return (
    <Container onLayout={onContainerLayout}>
      {isFullSizedDashAvailable ? (
        <LandscapeDashboardScreenView {...props} />
      ) : (
        <PortraitDashboardScreenView {...props} />
      )}

      <DeveloperScreenInfo />
    </Container>
  );
};

const Container = styled.View`
  flex: 1;
  margin: 4px;
`;
